import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormControl} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {UsersAnagrafService} from '../../../general-services/service-users-anagraf/users-anagraf.service';
import {UserModel} from '../../../../models/UserModel';

@Component({
  selector: 'app-user-name-filter',
  templateUrl: './user-name-filter.component.html',
  styleUrls: ['./user-name-filter.component.scss']
})
export class UserNameFilterComponent extends ProjectConstants implements OnInit, OnDestroy {

  listFilterNames: any[];

  namesFormControl = new FormControl();
  namesFilteredOptions: Observable<any[]>;

  getAllUsers: Subscription;

  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private usersService: UsersAnagrafService) {
    super();
    this.getAll();
  }

  ngOnInit() {
  }

  filterTable(): void {
    const filter: UserModel = new UserModel();

    filter.name = this.namesFormControl.value;

    this.dataFiltered.emit(filter);
  }

  getAll() {
    this.getAllUsers = this.usersService.getAll(this.usersService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.listFilterNames = result.filter(
            (thing, i, arr) => arr.findIndex(t => t.name.toUpperCase() === thing.name.toUpperCase()) === i
          );
          this.listFilterNames.sort((a, b) => a.name.localeCompare(b.name));

          this.namesFormControl.setValue(null);
          this.applyUserFormControlFilteredOptions();
        }
      );
  }

  // AUTOCOMPLETE Units

  applyUserFormControlFilteredOptions() {
    this.namesFilteredOptions = this.namesFormControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterUsersOptionList(value))
      );
  }

  displayNamesAutocompleteFn(element: any) {
    if (element) {
      return element.name;
    }
  }

  ngOnDestroy(): void {
  }

  private _filterUsersOptionList(value: string): string[] {
    if (value === '') {
      this.namesFormControl.setValue(null);
    }

    if (value == null) {
      value = '';
    } else if (typeof value !== 'string') {
      return null;
    }

    return this.listFilterNames.filter(option => {
      if (option.name.toLowerCase().includes(value.toLowerCase())) {
        return option;
      }
    });
  }

}
